import React from 'react';
import PropTypes from 'prop-types';
import { trackEvent } from 'dibs-tracking';
import classnames from 'classnames';
import HeartIcon from 'dibs-icons/exports/HeartOutlined';
import styles from './Likes-style.scss';

const trackingObj = {
    category: 'navigation',
    action: 'header navigation click',
    label: 'my favorites|my favorites header icon',
};

const LikesIcon = props => {
    const { onMouseEnter, favoritesUrl, hasUnread } = props;

    const heartIconClasses = classnames(styles.icon, {
        [styles.hasUnread]: hasUnread,
    });

    let iconWrapperProps = {
        className: styles.iconWrapper,
    };

    if (onMouseEnter) {
        iconWrapperProps = { ...iconWrapperProps, onMouseEnter };
    }

    return (
        <div {...iconWrapperProps}>
            <a
                data-tn="likes-link"
                href={favoritesUrl}
                className={heartIconClasses}
                onClick={() => {
                    trackEvent(trackingObj);
                }}
            >
                <HeartIcon />
            </a>
        </div>
    );
};

LikesIcon.propTypes = {
    onMouseEnter: PropTypes.func,
    favoritesUrl: PropTypes.string,
    hasUnread: PropTypes.bool,
};

LikesIcon.defaultProps = {
    hasUnread: false,
};

export default LikesIcon;
